module.exports = __webpack_public_path__ + "catalog/holes/panic-door-double/panicDoorDouble.png";